import type { AuthorizationService } from "@services/auth/authorization/authorization-service-impl";
import { PermissionsApp } from "@services/auth/authorization";

export function puedeGestionActivosGmao(autho: AuthorizationService): boolean {
  return (
    autho.hasPermission(PermissionsApp.EditAllActivosGmao) ||
    autho.hasPermission(PermissionsApp.GestionTicketingAll)
  );
}

export function esSatSoloActivos(autho: AuthorizationService): boolean {
  return (
    autho.hasPermission(PermissionsApp.GestionTicketingAll) &&
    !autho.hasPermission(PermissionsApp.EditAllActivosGmao) &&
    !autho.hasPermission(PermissionsApp.GestionAvanzadaActuacionesAll)
  );
}

export function puedeCrearActivo(autho: AuthorizationService): boolean {
  return (
    autho.hasPermission(PermissionsApp.CreateActivos) ||
    esSatSoloActivos(autho)
  );
}

export function puedeVerDashboardActivos(autho: AuthorizationService): boolean {
  return autho.hasPermission(PermissionsApp.EditAllActivosGmao);
}
